import { render, staticRenderFns } from "./Competency.vue?vue&type=template&id=5df7decc&scoped=true&"
import script from "./Competency.vue?vue&type=script&lang=js&"
export * from "./Competency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df7decc",
  null
  
)

export default component.exports